export const missionData = {
  1: {
    mission: 'B',
    primaryMission: 'Supply Drop',
    primaryMissionUrl: 'https://gdmissions.app/primary-missions/supply-drop',
    missionSvgUrl: 'https://gdmissions.app/assets/primary-missions/supply-drop.svg',
    deploymentType: 'Tipping Point',
    deploymentUrl: 'https://gdmissions.app/deployment-zones/tipping-point',
    deploymentSvgUrl: 'https://gdmissions.app/assets/deployment-zones/tipping-point.svg',
    stage: 'GROUP STAGE'
  },
  2: {
    mission: 'F',
    primaryMission: 'Hidden Supplies',
    primaryMissionUrl: 'https://gdmissions.app/primary-missions/hidden-supplies',
    missionSvgUrl: 'https://gdmissions.app/assets/primary-missions/hidden-supplies.svg',
    deploymentType: 'Hammer and Anvil',
    deploymentUrl: 'https://gdmissions.app/deployment-zones/hammer-and-anvil',
    deploymentSvgUrl: 'https://gdmissions.app/assets/deployment-zones/hammer-and-anvil.svg',
    stage: 'GROUP STAGE'
  },
  3: {
    mission: 'E',
    primaryMission: 'Take and Hold',
    primaryMissionUrl: 'https://gdmissions.app/primary-missions/take-and-hold',
    missionSvgUrl: 'https://gdmissions.app/assets/primary-missions/take-and-hold.svg',
    deploymentType: 'Hammer and Anvil',
    deploymentUrl: 'https://gdmissions.app/deployment-zones/hammer-and-anvil',
    deploymentSvgUrl: 'https://gdmissions.app/assets/deployment-zones/hammer-and-anvil.svg',
    stage: 'GROUP STAGE'
  },
  4: {
    mission: 'O',
    primaryMission: 'Terraform',
    primaryMissionUrl: 'https://gdmissions.app/primary-missions/terraform',
    missionSvgUrl: 'https://gdmissions.app/assets/primary-missions/terraform.svg',
    deploymentType: 'Crucible Of Battle',
    deploymentUrl: 'https://gdmissions.app/deployment-zones/crucible-of-battle',
    deploymentSvgUrl: 'https://gdmissions.app/assets/deployment-zones/crucible-of-battle.svg',
    stage: 'SWISS STAGE'
  },
  5: {
    mission: 'P',
    primaryMission: 'Scorched Earth',
    primaryMissionUrl: 'https://gdmissions.app/primary-missions/scorched-earth',
    missionSvgUrl: 'https://gdmissions.app/assets/primary-missions/scorched-earth.svg',
    deploymentType: 'Crucible Of Battle',
    deploymentUrl: 'https://gdmissions.app/deployment-zones/crucible-of-battle',
    deploymentSvgUrl: 'https://gdmissions.app/assets/deployment-zones/crucible-of-battle.svg',
    stage: 'SWISS STAGE'
  },
  6: {
    mission: 'J',
    primaryMission: 'Linchpin',
    primaryMissionUrl: 'https://gdmissions.app/primary-missions/linchpin',
    missionSvgUrl: 'https://gdmissions.app/assets/primary-missions/linchpin.svg',
    deploymentType: 'Search and Destroy',
    deploymentUrl: 'https://gdmissions.app/deployment-zones/search-and-destroy',
    deploymentSvgUrl: 'https://gdmissions.app/assets/deployment-zones/search-and-destroy.svg',
    stage: 'SWISS STAGE'
  },
  7: {
    mission: 'L',
    primaryMission: 'Take and Hold',
    primaryMissionUrl: 'https://gdmissions.app/primary-missions/take-and-hold',
    missionSvgUrl: 'https://gdmissions.app/assets/primary-missions/take-and-hold.svg',
    deploymentType: 'Search and Destroy',
    deploymentUrl: 'https://gdmissions.app/deployment-zones/search-and-destroy',
    deploymentSvgUrl: 'https://gdmissions.app/assets/deployment-zones/search-and-destroy.svg',
    stage: 'SWISS STAGE'
  }
};